<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="País">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="_ID" v-model="form._id" disabled />
                  <label for="_id">_ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="code" placeholder="Código" v-model="form.code" />
                  <label for="code">Código</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="name" placeholder="Nome" v-model="form.name" />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtBr" placeholder="Nome PT-BR" v-model="form.namePtBr" />
                  <label for="name">Nome PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEnEu" placeholder="Nome EN-EU" v-model="form.nameEnEu" />
                  <label for="name">Nome EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsEs" placeholder="Nome ES-ES" v-model="form.nameEsEs" />
                  <label for="name">Nome ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsAr" placeholder="Nome ES-AR" v-model="form.nameEsAr" />
                  <label for="name">Nome ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtPt" placeholder="Nome PT-PT" v-model="form.namePtPt" />
                  <label for="namePtPt">Nome PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameZhCn" placeholder="Nome ZH-CN" v-model="form.nameZhCn" />
                  <label for="nameZhCn">Nome ZH-CN</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="iso" placeholder="ISO (ex: br, cn)" v-model="form.iso" />
                  <label for="iso">ISO</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="language-list">Idioma</label>
                  <b-form-group label="Language" label-for="language-list">
                  <v-select
                    id="language-list"
                    v-model="form.language"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="languages"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="wdma_route-list">Wdma Route</label>
                  <b-form-group label="Wdma Route" label-for="wdma_route-list">
                  <v-select
                    id="wdma_route-list"
                    v-model="form.wdma_route"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="wdmaRoutes"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="locale-list">Locale</label>
                  <b-form-group label="locale" label-for="locale-list">
                  <v-select
                    id="locale-list"
                    v-model="form.locale"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="locales"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="lang-list">Lang</label>
                  <b-form-group label="lang" label-for="lang-list">
                  <v-select
                    id="lang-list"
                    v-model="form.lang"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="langs"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="locale" placeholder="Locale" v-model="form.locale" />
                  <label for="locale">Locale</label>
                </div> 
              </b-col>-->

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="enableToSendReport" name="enableToSendReport" checked="true" v-model="form.enableToSendReport">
                    Habilitar no envio de relatório
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import countryService from "@/providers/countryService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      languages: [],
      wdmaRoutes: [],
      locales: [
        "PtBr",
        "EnEu",
        "EsEs",
        "EsAr",
        "PtPt",
        "ZhCn",
      ],
      langs: [
        "pt-BR",
        "en-EU",
        "es-AR",
        "es-ES",
        "pt-PT",
        "zh-CN",
      ],
      form: {
        _id: "",
        code: "",
        name: "",
        namePtBr: "",
        nameEsAr: "",
        nameEsEs: "",
        nameEnEu: "",
        namePtPt: "",
        nameZhCn: "",
        locale: "",
        lang: "",
        iso: "",
        active: true,
        enableToSendReport: true,
        language: "",
        wdma_route: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo País');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo País');
      }
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_COUNTRY);
    },
    onSubmit() {
      countryService
        .registerCountry(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getCountryDetails() {
      const params = new URLSearchParams();
      countryService
        .getCountryDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.code = res.code;
          this.form.name = res.name;
          this.form.namePtBr = res.namePtBr;
          this.form.nameEnEu = res.nameEnEu;
          this.form.nameEsAr = res.nameEsAr;
          this.form.nameEsEs = res.nameEsEs;
          this.form.namePtPt = res.namePtPt;
          this.form.nameZhCn = res.nameZhCn;
          this.form.locale = res.locale;
          this.form.lang = res.lang;
          this.form.iso = res.iso;
          this.form.language = {id: res.language._id, name: res.language.name};
          this.form.wdma_route = {id: res.wdma_route._id, name: res.wdma_route.name};
          this.form.enableToSendReport = res.enableToSendReport;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getAllLanguage(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
      ]).then((res) => {
          this.languages = res[0];
          this.wdmaRoutes = res[1];
          if (this.isUpdate) {
            this.getCountryDetails();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>